import React, {Component} from 'react'
// import { Row, Col, FormControl, Modal, Form, FormGroup, Button } from 'react-bootstrap'
import { Checkbox } from 'react-icheck'
import PrintPreview from './PrintPreview'
import FontAwsome from 'react-fontawesome'
import WorkdocStore from '../../stores/WorkdocStore'
import TextFieldModal from '../../component/element/TextFieldModal'

var NotificationSystem = require('react-notification-system');
const CHECK_LIST = [{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[{t:''},{t:''}]},{p:'',note:'',title:[{t:''},{t:''}]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]}]

class PrintKKCWorkQCDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,allList:{checkList:CHECK_LIST},page_title:'กำลังดึงข้อมูล..'}
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadWorkdocRelated()
  }

  loadWorkdocRelated() {
    let {workNo} = this.props
    let {allList} = this.state
    WorkdocStore.loadWorkdocRelated(workNo,'kkc_work_qc_doc',(result)=>{
      if (result.data.length===0||result.data.allList===undefined||result.data.allList.checkList.length===0) {
        this.setState({allList:{checkList:CHECK_LIST},page_title:'ไม่พบข้อมูล'})
      } else {
        this.setState({allList:result.data.allList,page_title:'ไม่พบข้อมูล'})
      }  
    }) 
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  onNoteClick(key,value,e){
    let fieldInfo = {title:'หมายเหตุ',showClear:false,value:value,key:key,save:'note'}
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }
    
  onNoteSave(fieldInfo) {
    let {allList} = this.state
    if (fieldInfo.save==='note') {
      let note = fieldInfo.value === undefined ? '' : fieldInfo.value
      allList.checkList[fieldInfo.key].note = note
    } else if (fieldInfo.save==='title') {
      let value = fieldInfo.value === undefined ? '' : fieldInfo.value
      allList.checkList[fieldInfo.key].title[fieldInfo.sub_key].t = value
    }
    this.setState({allList:allList})
    this.saveDamagePartDoc() 
  }

  onTitleClick(key,sub_key,value,e){
    let fieldInfo = {title:'บันทึกรายการ',showClear:false,value:value,key:key,sub_key:sub_key,save:'title'}
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }

  onTdCheckClick(key,value,e) { 
    let {allList} = this.state
    if (allList.checkList[key].p===value)
      value = ''
    else if (allList.checkList[key].p===''&&value===false)
      value = false
    else if (allList.checkList[key].p===''&&value==='NON')
      value = 'NON'
    else
      value = value
    allList.checkList[key].p = value
    this.setState({allList:allList})
    this.saveDamagePartDoc()
  }
  
  onTitleChange(key,key1,value,e) {
    let {allList} = this.state
    allList.checkList[key].title[key1].t = value === true ? false : true
    this.setState({allList:allList})
    this.saveDamagePartDoc()
  }

  saveDamagePartDoc() {
    let {allList} = this.state
    let {workNo} = this.props
    let all_List = {allList:allList}
    WorkdocStore.saveWorkdocRelated(workNo,'kkc_work_qc_doc',all_List,(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })
  }

  onDocChange() {

  }

  renderRowTitle(text='',text1='',text2='',text3='',text4='') {
    return(
            <tr>
              <td style={{width:'500px',fontWeight:'bold'}} className='text-center'>{text}</td>
              <td style={{width:'50px'}} className='text-center'>{text1}</td>
              <td style={{width:'50px'}} className='text-center'>{text2}</td>
              <td style={{width:'50px'}} className='text-center'>{text3}</td>
              <td style={{width:'200px'}} className='text-center'>{text4}</td>
            </tr>
    )
  }

  renderRowSubTitle(title='') {
    return(
            <tr>
              <td style={{width:'500px',fontWeight:'bold'}}>{title}</td>
              <td style={{width:'50px'}} className='text-center'></td>
              <td style={{width:'50px'}} className='text-center'></td>
              <td style={{width:'50px'}} className='text-center'></td>
              <td style={{width:'200px'}} className='text-center'></td>
            </tr>
    )
  }

  renderTdAction(key) {
    let {allList} = this.state
    return([
      <td className='text-center' onClick={this.onTdCheckClick.bind(this,key,true)}>{allList.checkList[key].p===true?<FontAwsome style={{fontSize:'14px'}} name='check' />:''}</td>,
      <td className='text-center' onClick={this.onTdCheckClick.bind(this,key,false)}>{allList.checkList[key].p===false?<FontAwsome style={{fontSize:'14px'}} name='check' />:''}</td>,
      <td className='text-center' onClick={this.onTdCheckClick.bind(this,key,'NON')}>{allList.checkList[key].p==='NON'?<FontAwsome style={{fontSize:'14px'}} name='check' />:''}</td>,
      <td onClick={this.onNoteClick.bind(this,key,allList.checkList[key].note)}>{allList.checkList[key].note}</td>
    ])
  }

  renderSec0() {
    let {allList} = this.state
    return([
      <tr key={0}>
        <td>- ตัวถัง, ตู้บรรทุก, ตัวล็อกต่างๆ เช่น ประตู, ฝาท้าย, กระบะ (ใช้งานได้, ไม่ชำรุด, ไม่รั่วซึม)</td>
        {this.renderTdAction(0)}
      </tr>,
      <tr key={1}>
        <td>- ที่ปัดน้ำฝน (ใช้งานได้ครบตามมาตราฐานของรถ)</td>
        {this.renderTdAction(1)}
      </tr>,
      <tr key={2}>
        <td>- เข็มขัดนิรภัย (ใช้งานได้)</td>
        {this.renderTdAction(2)}
      </tr>,
      <tr key={3}>
        <td>- สภาพล้อยาง</td>
        {this.renderTdAction(3)}
      </tr>,
      <tr key={4}>
        <td>- ศูนย์ล้อหน้า</td>
        {this.renderTdAction(4)}
      </tr>,
      <tr key={5}>
        <td>- แผ่นบังโคลน</td>
        {this.renderTdAction(5)}
      </tr>,
      <tr key={6}>
        <td>- เพลาล้อ</td>
        {this.renderTdAction(6)}
      </tr>,
      <tr key={7}>
        <td>- เพลาส่งกำลัง ห่วงรองรับและข้อต่อ</td>
        {this.renderTdAction(7)}
      </tr>,
      <tr key={8}>
        <td>- ถังเชื้อเพลิงและท่อส่ง</td>
        {this.renderTdAction(8)}
      </tr>,
      <tr key={9}>
        <td>- ระบบสั่นสะเทือน (โช๊ค แหนบ ลูกหมาก)</td>
        {this.renderTdAction(9)}
      </tr>,
      <tr key={10}>
        <td>- ระบบสตาร์ท</td>
        {this.renderTdAction(10)}
      </tr>,
      <tr key={11}>
        <td>- ระบบบังคับเลี้ยว</td>
        {this.renderTdAction(11)}
      </tr>,
      <tr key={12}>
        <td>- คลัตซ์ เฟือง เฟืองท้าย</td>
        {this.renderTdAction(12)}
      </tr>,
      <tr key={13}>
        <td>- ระบบไอเสีย</td>
        {this.renderTdAction(13)}
      </tr>,
      <tr key={14}>
        <td>- ควันดำ<span onClick={this.onTitleClick.bind(this,14,0,allList.checkList[14].title[0].t)}>{allList.checkList[14].title[0].t===''?'................':' '+allList.checkList[14].title[0].t+' '}</span>% (ระบบ<span onClick={this.onTitleClick.bind(this,14,1,allList.checkList[14].title[1].t)}>{allList.checkList[14].title[1].t===''?'................':' '+allList.checkList[14].title[1].t}</span>)</td>
        {this.renderTdAction(14)}
      </tr>,
      <tr key={15}>
        <td>- ระบบเสียงของรถ<span onClick={this.onTitleClick.bind(this,15,0,allList.checkList[15].title[0].t)}>{allList.checkList[15].title[0].t===''?'................':' '+allList.checkList[15].title[0].t+' '}</span>เดซิเบล A (ที่<span onClick={this.onTitleClick.bind(this,15,1,allList.checkList[15].title[1].t)}>{allList.checkList[15].title[1].t===''?'................':' '+allList.checkList[15].title[1].t+' '}</span>ม.)</td>
        {this.renderTdAction(15)}
      </tr>
    ])
  }

  renderSec1() {
    return([
      <tr key={0}>
        <td>- ไฟหน้ารถ ซ้าย-ขวา, ไฟสูง-ต่ำ, ไฟตัดหมอก (ใช้งานได้, สว่าง)</td>
        {this.renderTdAction(16)}
      </tr>,
      <tr key={1}>
        <td>- ไฟเลี้ยว ซ้าย-ขวา (ใช้งานได้, สว่าง)</td>
        {this.renderTdAction(17)}
      </tr>,
      <tr key={2}>
        <td>- ไฟท้าย/ไฟเบรค ซ้าย-ขวา (ใช้งานได้, สว่าง)</td>
        {this.renderTdAction(18)}
      </tr>,
      <tr key={3}>
        <td>- ไฟและเสียงสัญญาณถอยหลัง ซ้าย-ขวา (ใช้งานได้, สว่าง, ดัง)</td>
        {this.renderTdAction(19)}
      </tr>,
      <tr key={4}>
        <td>- ไฟสัญญาณฉุกเฉิน (ใช้งานได้, สว่าง)</td>
        {this.renderTdAction(20)}
      </tr>,
      <tr key={5}>
        <td>- สัญญาณแตร (ใช้งานได้, ดัง)</td>
        {this.renderTdAction(21)}
      </tr>
    ])
  }  

  renderSec2() {
    return([
      <tr key={0}>
        <td>- น้ำมันเบรค (อยู่ในระดับที่กำหนด)</td>
        {this.renderTdAction(22)}
      </tr>,
      <tr key={1}>
        <td>- ประสิทธิภาพห้ามล้อมือ (ใช้งานได้)</td>
        {this.renderTdAction(23)}
      </tr>,
      <tr key={2}>
        <td>- ประสิทธิภาพห้ามล้อเท้า (ใช้งานได้)</td>
        {this.renderTdAction(24)}
      </tr>
    ])
  }

  renderSec3() {
    return([
      <tr key={0}>
        <td>- น้ำมันเครื่อง (ไม่รั่วซึม)</td>
        {this.renderTdAction(25)}
      </tr>,
      <tr key={1}>
        <td>- น้ำมันเกียร์ (ไม่รั่วซึม)</td>
        {this.renderTdAction(26)}
      </tr>,
      <tr key={2}>
        <td>- น้ำมันเฟืองท้าย (ไม่รั่วซึม)</td>
        {this.renderTdAction(27)}
      </tr>,
      <tr key={3}>
        <td>- น้ำมันปลายท่อไอเสีย (ไม่รั่วซึม)</td>
        {this.renderTdAction(28)}
      </tr>,
      <tr key={4}>
        <td>- น้ำมันเพลาท้าย (ไม่รั่วซึม)</td>
        {this.renderTdAction(29)}
      </tr>
    ])
  }  

  renderSignature() {
    return(
      <tr>
        <td style={{width:'33.33%'}} className='hr-r-none text-center'>{this.renderTableSignature('','รองรับโดยผู้ตรวจ')}</td>
        <td style={{width:'33.33%'}} className='hr-r-none text-center'>{this.renderTableSignature('','อนุมัติโดย ผู้จัดการ/ผู้ช่วยผู้จัดการ')}</td>
        
      </tr>
    )
  }

  renderTableSignature(text='',text1='') {
    return(
      <table className='table table-print-kkc-work-qc-doc'>
        <tbody>
          <tr>
            <td className='text-center'>{text1}</td>
          </tr>
          <tr>
            <td className='text-center'><br/><br/><br/></td>
          </tr>
          <tr>
            <td className='text-center'>.............../.............../...............</td>
          </tr>
        </tbody>
      </table>
    )
  }

  renderComponentPage() {
    let {data} = this.state

    return(
      <div className='font-print font-14'>
        <table className='table table-print-kkc-work-qc-doc' style={{marginBottom:'0'}}>
          <tbody>
            <tr>
              <td style={{width:'15%'}} className='hr-r-none hr-b-none'>{this.renderLogoUrl()}</td>
              <td style={{width:'70%'}} className='hr-r-none hr-b-none row-title text-center'>
                {this.props.title}<br/>
                ({this.props.title_eng})
              </td>
              <td style={{width:'15%'}} className='hr-b-none font-14'>ตรวจครั้งที่ .....<br/>วันที่ตรวจ.......................</td>
            </tr>
          </tbody>
        </table>
        <table className='table table-print-kkc-work-qc-doc' style={{marginBottom:'-1px'}}>
          <tbody>
            <tr>
              <td className='hr-r-none hr-b-none' style={{width:'8%'}}>ชื่อบริษัท</td>
              <td className='hr-r-none hr-b-dotted' style={{width:'15%'}}></td>
              <td className='hr-r-none hr-b-none' style={{width:'6%'}}>เบอร์รถ</td>
              <td className='hr-r-none hr-b-dotted' style={{width:'16%'}}></td>
              <td className='hr-r-none hr-b-none' style={{width:'10%'}}>เลขทะเบียน</td>
              <td className='hr-r-none hr-b-dotted' style={{width:'20%'}}></td>
              <td className='hr-r-none hr-b-none' style={{width:'5%'}}>จังหวัด</td>
              <td className='hr-b-dotted' style={{width:'20%'}}></td>
            </tr>
          </tbody>
        </table>    
        <table className='table table-print-kkc-work-qc-doc' style={{marginBottom:'-1px'}}>
          <tbody>     
            <tr>
              <td className='hr-t-none hr-r-none hr-b-none' style={{width:'6%'}}>ยี่ห้อ/รุ่น</td>
              <td className='hr-t-none hr-r-none hr-b-dotted' style={{width:'7%'}}></td>
              <td className='hr-t-none hr-r-none hr-b-none' style={{width:'11%'}}>เลขตัวรถหรือโครงคัสซี่</td>
              <td className='hr-t-none hr-r-none hr-b-dotted' style={{width:'20%'}}></td>
              <td className='hr-t-none hr-r-none hr-b-none' style={{width:'8%'}}>เลขเครื่องยนต์</td>
              <td className='hr-t-none hr-b-dotted' style={{width:'22%'}}></td>
            </tr>
          </tbody>
        </table>
        <table className='table table-print-kkc-work-qc-doc' style={{marginBottom:'-2px'}}>
          <tbody>  
            <tr>
              <td className='hr-t-none hr-r-none hr-b-none'>ลักษณะรถ : </td>
              <td className='hr-t-none hr-r-none hr-b-none'>
                <Checkbox
                  onChange={this.onDocChange.bind(this)}
                  checked={false}
                  checkboxClass="icheckbox_minimal"
                  increaseArea="20%"
                  label={' รถบรรทุก 6 ล้อ 5 เมตร'}
                >
                </Checkbox>
              </td>
              <td className='hr-t-none hr-r-none hr-b-none'>
                <Checkbox
                  onChange={this.onDocChange.bind(this)}
                  checked={false}
                  checkboxClass="icheckbox_minimal"
                  increaseArea="20%"
                  label={' รถบรรทุก 6 ล้อ 7 เมตร'}
                >
                </Checkbox>
              </td>
              <td className='hr-t-none hr-r-none hr-b-none'>
                <Checkbox
                  onChange={this.onDocChange.bind(this)}
                  checked={false}
                  checkboxClass="icheckbox_minimal"
                  increaseArea="20%"
                  label={' รถบรรทุก 10 ล้อ'}
                >
                </Checkbox>
              </td>
              <td className='hr-t-none hr-r-none hr-b-none'>
                <Checkbox
                  onChange={this.onDocChange.bind(this)}
                  checked={false}
                  checkboxClass="icheckbox_minimal"
                  increaseArea="20%"
                  label={' รถยนต์กระบะ'}
                >
                </Checkbox>
              </td>
              <td className='hr-t-none hr-r-none hr-b-none'>
                <Checkbox
                  onChange={this.onDocChange.bind(this)}
                  checked={false}
                  checkboxClass="icheckbox_minimal"
                  increaseArea="20%"
                  label={' รถตู้'}
                >
                </Checkbox>
              </td>
              <td className='hr-t-none hr-b-none'>
                <Checkbox
                  onChange={this.onDocChange.bind(this)}
                  checked={false}
                  checkboxClass="icheckbox_minimal"
                  increaseArea="20%"
                  label={' รถเก๋ง'}
                >
                </Checkbox>
              </td>
            </tr>  
          </tbody>
        </table>
        <table className='table table-print-kkc-work-qc-doc' style={{marginBottom:'-1px'}}>
          <tbody>
            {this.renderRowTitle('รายการที่ตรวจ','ผ่าน','ไม่ผ่าน','ไม่มี','หมายเหตุ')}            
            {this.renderRowSubTitle('1. สภาพทั่วไป')}
            {this.renderSec0()}
            {this.renderRowSubTitle('2. ระบบไฟส่องสว่าง/เสียงสัญญาณ')}
            {this.renderSec1()}
            {this.renderRowSubTitle('3. ระบบเบรค')}
            {this.renderSec2()}
            {this.renderRowSubTitle('4. สภาพการรั่วของน้ำมัน')}
            {this.renderSec3()}
          </tbody>
        </table>  
        <table className='table table-print-kkc-work-qc-doc'>
          <tbody>
            {this.renderSignature()}
          </tbody>
        </table>     
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    return(
      <div>
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
          sliptable={'sliptable-page-padding02-desktop'}
        >
          {this.renderComponentPage()}
        </PrintPreview>
        <TextFieldModal 
          ref='textFieldModal'
          confirmTitle='บันทึก'
          onConfirm={this.onNoteSave.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }
}  

PrintKKCWorkQCDoc.defaultProps = {
  title: 'แบบตรวจรับรถก่อนส่งมอบลูกค้า',
  title_eng: 'Vihicle Part Insspection Form',  
  mode : '1'
}
export default PrintKKCWorkQCDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintKKCWorkQCDoc.js